import { render } from "./5PenempatandanPelatihanTenagaKerja.vue?vue&type=template&id=19b140d0&scoped=true"
import script from "./5PenempatandanPelatihanTenagaKerja.vue?vue&type=script&lang=js"
export * from "./5PenempatandanPelatihanTenagaKerja.vue?vue&type=script&lang=js"

import "./5PenempatandanPelatihanTenagaKerja.vue?vue&type=style&index=0&id=19b140d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b140d0"]])

export default __exports__